//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
// import { cloneDeep } from 'lodash';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const iInitial = {
    session_id:null,
    created_by:null,
    class_id:null,
    created_on:null,
    status:'',
    game_data:{},
    user_seen:[]  

}
export const currentGameSession =  (state = iInitial, action) => {
    switch (action.type) {
        case ActionTypes.game.set_current_game_session:
            return action.payload
        case ActionTypes.game.update_current_game_session:
            return ({...state,...action.payload});
        case ActionTypes.game.clear_current_game_session:
            return iInitial;
        default:
            return state;
    }
};